import React from 'react'
import { observer } from 'mobx-react'

import Typography from '../../../../../UniformComponents/Typography'
import BubbleLoader from '../../../../../UniformComponents/BubbleLoader'

const AiOverview = ({ store, summary, children }) => {
    const { generatingSummary, summaryStatus } = store

    const summaryStatusIcon = () => {
        if (!summaryStatus?.style) return null

        const iconClass = summaryStatus?.style !== 'success'
            ? 'fa-regular fa-circle-check'
            : 'fa-solid fa-clock'

        return (
            <div class={`icon-status ${summaryStatus?.style}`} onClick={store.toggleShowAiAssistant}>
               <i className={iconClass} />
            </div>
        )
    }

    return process.env.SHOW_AI_ASSISTANT ? (
        <div id="aiOverview">
            <div className="container" style={{ width: '100%' }}>
                {summaryStatusIcon()}
                <div className="icon-container">
                    <i className="fas fa-sparkles" />
                </div>

                {generatingSummary ? (
                    <div className="generating-container">
                        <BubbleLoader />
                    </div>
                ) : (
                    <Typography>
                        {summary}
                    </Typography>
                )}
                {children}
            </div>
        </div>
    ) : null
}

export default observer(AiOverview)
